import { FC, memo } from 'react';
import classNames from 'classnames';
import { useLoginContext } from '../LoginProvider';
import { BrokerConfig } from '../types.type';

type BrokerListViewProps = {
  list: BrokerConfig;
  isHovered?: boolean;
};

const BrokerListView: FC<BrokerListViewProps> = ({ list, isHovered }) => {
  const { state, handleLogin } = useLoginContext();
  const selectedBroker = state.selectedBrokerConfig?.id;

  const combinedClassName = classNames('broker-list-view', {
    active: selectedBroker === list.id,
    hovered: isHovered,
  });

  const freeBrokers: string[] = [];

  return (
    <div className={combinedClassName} onClick={() => handleLogin(list)} id={`broker-${list.id}`}>
      <div className="broker-list-view__content">
        <div className="broker-list-view__img">
          <img src={`/images/brokers/compact/${list.id}.svg`} alt={list.name} />
        </div>

        <div className="broker-list-view__label">{list.name}</div>
      </div>
      {freeBrokers.includes(list.id) && (
        <div className="glowing-button-wrapper">
          <div className="glowing-button">FREE</div>
        </div>
      )}
    </div>
  );
};

export default memo(BrokerListView);
